<template>
  <div class="spinner-container">
    <div class="spinner"></div>
    <p>{{ message }} ...</p>
  </div>
</template>

<script>
export default {
  name: "LoadingSpinner",
  props: {
    message: String,
  },
};
</script>

<style scoped>
.spinner-container {
  overflow: hidden;
  opacity: 0.75;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  margin: 5px 0;
}

.spinner {
  transition-timing-function: linear;
  border-radius: 9999px;
  border-top-width: 4px;
  height: 3rem;
  width: 3rem;
  margin-bottom: 4px;
  border-top: 2px solid #f7723e;

  -webkit-animation: spinner 1.5s linear infinite;
  animation: spinner 1.5s linear infinite;
}

.spinner-container p {
  font-family: "AvenirRoman";
  text-align: center;
  font-size: 20px;
  color: black;
}

@-webkit-keyframes spinner {
  0% {
    -webkit-transform: rotate(0deg);
  }
  100% {
    -webkit-transform: rotate(360deg);
  }
}

@keyframes spinner {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
